"use client"

// קליקרים - ראשי
import { useState, useEffect, useRef } from "react"
import { useParams, useNavigate, useSearchParams } from "react-router-dom"
import backgroundImage from "./21.jpg"
import { getTokens } from "./gameThemes"
import { Box, Slider, Dialog, DialogTitle, DialogContent, IconButton, Typography, Chip } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import "./App.css"
import io from "socket.io-client"
import { CircularProgressbar, buildStyles } from "react-circular-progressbar"
import ArrowBackIcon from "@mui/icons-material/ArrowBack" // אייקון לדוגמה
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import ReplayIcon from "@mui/icons-material/Replay"
import RestartAltIcon from "@mui/icons-material/RestartAlt"
import PauseCircleIcon from "@mui/icons-material/PauseCircle"
import StopCircleIcon from "@mui/icons-material/StopCircle"
import VolumeOffIcon from "@mui/icons-material/VolumeOff"
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents"
import MusicNoteIcon from "@mui/icons-material/MusicNote"
import SignLanguageIcon from "@mui/icons-material/SignLanguage"
import { Icon } from "semantic-ui-react"
import styled from "styled-components"
import { API_URL, WS_URL } from './config';

const OverlayContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7); /* רקע כהה שקוף */
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000; /* מעלה מעל כל התוכן */
    padding: 10px; /* רווחים מסביב לתמונה */
`

const ImageContainer = styled.div`
    background-color: white; /* רקע לבן למסגרת */
    padding: 10px; /* מרווח פנימי */
    border-radius: 10px; /* פינות מעוגלות */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* צל יפה למסגרת */
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 90%; /* גודל מקסימלי של התמונה לפי רוחב המסך */
    max-height: 90%; /* גובה מקסימלי לפי גובה המסך */
    height: 90%; /* קביעת הגובה ל-90% מגובה המסך */
`

const OverlayImage = styled.img`
    width: auto; /* תואם את רוחב התמונה */
    height: 100%; /* הגובה נשאר קבוע לפי 90% מהגובה של התמונה */
    object-fit: contain; /* שומר על יחס הגובה-רוחב של התמונה */
    border: 5px solid turquoise; /* מסגרת צבעונית לתמונה */
    border-radius: 5px; /* עיגול המסגרת של התמונה */
`

let isVideo = false

/*** סרגל */
const ProgressBar = ({ trailBg = "rgba(255, 216, 131, 0.3)", borderColor = "brown" }) => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval)
          return 100 // הסרגל מלא
        }
        return prev + 1 // התקדמות ל-100% תוך 8 שניות
      })
    }, 20) // כל 80ms מעדכן (שווה ערך ל-8 שניות ל-100%)

    return () => clearInterval(interval) // ניקוי האינטרוואל לאחר סיום
  }, [])

  return (
    <div
      style={{
        width: "50%", // רוחב הסרגל
        maxWidth: "700px",
        height: "15px", // גובה הסרגל
        backgroundColor: trailBg, // רקע הסרגל (לפי התבנית)
        borderRadius: "10px", // פינות עגולות למסגרת
        border: `2px solid ${borderColor}`, // גבול (לפי התבנית)
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)", // צל למסגרת
        overflow: "hidden", // למנוע חריגה של הצבע הפנימי
      }}
    >
      <div
        style={{
          width: `${progress}%`, // התקדמות הסרגל
          height: "100%", // גובה מלא
          background: "linear-gradient(90deg, #32c5ff, #00ffc6)", // מעבר צבע טורקיז
          borderRadius: "8px", // פינות עגולות של הצבע
          boxShadow: "0 0 15px #00ffc6", // אפקט זוהר
          transition: "width 0.1s linear", // מעבר חלק
        }}
      ></div>
    </div>
  )
}

/**** טעינת שעון */
const CountdownCircle = ({ initialTime, start, reset, end, pathColor = "turquoise", trailColor = "rgba(255, 216, 131, 0.3)" }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime)

  useEffect(() => {
    // איפוס הטיימר במצב reset
    if (reset) {
      setTimeLeft(initialTime)
    }
  }, [reset, initialTime])

  useEffect(() => {
    let timer
    if (start) {
      const updateTimer = () => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer) // עצירת הטיימר
            end() // קריאה לפונקציה כשהטיימר מסתיים
            return 0
          }
          return prevTime - 1
        })
      }

      // קריאה ראשונית
      updateTimer()
      // הפעלה מתוזמנת כל שניה
      timer = setInterval(updateTimer, 1000)
    }

    return () => clearInterval(timer) // ניקוי טיימר קיים
  }, [start])

  const percentage = (timeLeft / initialTime) * 100

  return (
    <div style={{ width: "180px", height: "180px", position: "relative" }}>
      <CircularProgressbar
        value={percentage}
        styles={buildStyles({
          textColor: "#fff", // צבע הטקסט
          textSize: "16px", // גודל הטקסט.
          transition: "width 0.1s linear",
          pathColor: pathColor, // צבע העיגול המסתובב (לפי התבנית)
          trailColor: trailColor, // צבע הרקע של המסלול (לפי התבנית)
          strokeLinecap: "round", // סיומת מעוגלת לעיגול המתקדם
        })}
        strokeWidth={4} // זה מה שישנה את עובי העיגול
      />
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)", // מרכז את הטקסט
          color: "#fff",
          fontSize: "3rem",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        {timeLeft}
      </div>
    </div>
  )
}

/*** טעינת הדף */
const App = () => {
  //קבלת שם משחק
  const { gameId } = useParams()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const isDemo = gameId === "demo" // מצב הדגמה — משחק אמיתי עם שאלת דוגמה, ללא רשת
  const demoTheme = searchParams.get("theme") || "classic"

  //הגדרות עדכון
  const [questionData, setQuestionData] = useState() //מכיל שאילות
  // אתחול עם theme מהקאש (localStorage) — כדי שהרקע המתאים יופיע *מיד* ולא רק אחרי ה-API
  const [infoData, setInfoData] = useState(() => {
    try {
      const t = gameId && localStorage.getItem(`clicker_theme_${gameId}`)
      return t ? { theme: t } : undefined
    } catch (e) { return undefined }
  })
  const [viewCountdown, setViewCountdown] = useState(false) //הפעל שעון
  const [startCountdown, setStartCountdown] = useState(false) //הפעל שעון
  const [visibleQuestion, setVisibleQuestion] = useState(false) //הצג שאילה
  const [resetTimer, setResetTimer] = useState(false) //איפוס טיימר
  const [visibleAnswers, setVisibleAnswers] = useState(0) //מיקום שאילה
  const [typeQ, setTypeQ] = useState("") //סוג שאילה
  const [updates, setUpdates] = useState([])
  const [endQ, setEndQ] = useState(false)
  const [connectedUsers, setConnectedUsers] = useState(localStorage.getItem("connectedPlayers") || 0)
  const [timerEnd, setTimerEnd] = useState(false)
  const [startTiTiTi, setStartTiTiTi] = useState(false)
  const [startProgress, setStartProgress] = useState(false) //הפעלת סרגל
  const [showImage, setShowImage] = useState(false)
  const [playersDialogOpen, setPlayersDialogOpen] = useState(false)
  const [playersDialogAnswer, setPlayersDialogAnswer] = useState(null)

  //הגדרות שמע
  const [isPlaying, setIsPlaying] = useState(false)
  const [isPlayingClaps, setIsPlayingClaps] = useState(false)
  const [isPlayingDrama, setIsPlayingDrama] = useState(false)
  const [isPlayingAll, setIsPlayingAll] = useState(true)
  const [isStopTimer, setIsStopTimer] = useState(false)
  const [volume, setVolume] = useState(1)

  //setIsPlayingAll

  /***** סוף תמונה */

  /***** אייקונים */
  const buttons = [
    { id: 1, icon: <ReplayIcon />, type: "res", action: "now", text: "חזור שוב" },
    { id: 2, icon: <ArrowForwardIcon />, type: "res", action: "old", text: "שאילה קודמת" },
    { id: 3, icon: <PauseCircleIcon />, type: "res", action: "now", text: "השהייה" },
    { id: 4, icon: <ArrowBackIcon />, type: "res", action: "next", text: "שאילה הבאה" },
    {
      id: 5,
      icon: <VolumeOffIcon />,
      type: "play",
      action: isPlayingAll ? "stopAll" : "startAll",
      text: isPlayingAll ? "השתקה" : "ביטול השתקה",
    },
    { id: 6, icon: <RestartAltIcon />, type: "res", action: "reset", text: "אפס משחק" },
    { id: 7, icon: <EmojiEventsIcon />, type: "res", action: "leaders", text: "מובילים" },
    {
      id: 8,
      icon: <MusicNoteIcon />,
      type: "play",
      action: !isPlayingDrama ? "wow" : "stopWow",
      text: !isPlayingDrama ? "מנגינת דרמה" : "עצור מנגינה",
    },
    {
      id: 9,
      icon: <SignLanguageIcon />,
      type: "play",
      action: !isPlayingClaps ? "clap" : "stopClap",
      text: !isPlayingClaps ? "כפיים" : "הפסק כפיים",
    },
    { id: 10, icon: <StopCircleIcon />, type: "res", action: "end", text: "סיום משחק" },
  ]

  /***** סוף אייקונים */

  /***** תבנית עיצוב — משנה את כל צורות האלמנטים (ברירת מחדל: רגיל / קיר אבנים) */
  const T = getTokens(infoData?.theme)
  const backgroundStyle = T.isImage
    ? {
        backgroundImage: `url(${backgroundImage}), url(${backgroundImage})`,
        backgroundPosition: "center center",
        backgroundSize: "100% 100%",
        height: "100vh",
        width: "100vw",
        position: "fixed",
      }
    : {
        background: T.pageBg,
        backgroundSize: "cover",
        backgroundPosition: "center center",
        height: "100vh",
        width: "100vw",
        position: "fixed",
      }

  /***** סוף תמ"ר */

  /***** מתחיל שעון */
  //נגמר טיימר
  const handleEnd = () => {
    playPause("stopTimer")
    setTimerEnd(true)
    if (isDemo) return // בדמו אין קריאת שרת
    const params = new URLSearchParams()
    params.append("type", "time")
    params.append("game", gameId)
    fetch(`${API_URL}/end`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params.toString(),
    })
    console.log("Immediate action on end")
  }

  /***** נגמר שעון */

  //טעינת שאילות
  const loadQuestionData = (type) => {
    setStartTiTiTi(true)
    fetch(`${API_URL}/get_q/${type}/${gameId}`)
      .then((response) => response.json())
      .then((data) => {
        if (!data) {
          console.error("No valid data received")
          return
        }
        if (data.type == "end") {
          stopAllMusic()
          navigate(`/winn/${gameId}`)
        }
        setQuestionData(data)
        console.log("Question Data:", data)
        setTypeQ(data.type)
        setResetTimer(false)
      })
      .catch((error) => {
        console.error("Error fetching question data:", error)
      })
  }

  const loadGameData = () => {
    fetch(`${API_URL}/get_info/${gameId}`)
      .then((response) => response.json())
      .then((data) => {
        if (!data) {
          console.error("Error info")
          return
        }
        setConnectedUsers(data.connectedPlayers)
        setInfoData(data)
        // שמירת ה-theme לקאש כדי שהרקע יופיע מיד בטעינות הבאות
        try { localStorage.setItem(`clicker_theme_${gameId}`, data.theme || "classic") } catch (e) {}
      })
      .catch((error) => {
        console.error("Error fetching info data:", error)
      })
  }

  // פונקציה להציג את השאלה והתשובות
  const displayQuestionAndAnswers = () => {
    console.log("test:" + questionData)
    if (!questionData) return

    // חבא את התמונה אם היא מוצגת לפני הצגת שאלה חדשה
    if (showImage) {
      setShowImage(false)
    }

    console.log(questionData)

    // בדיקה וסידור סוג השאלה
    if (questionData.type === "p") {
      isVideo = false
      // הצגת התמונה
      setShowImage(true)
      // אחרי 8 שניות, הסתרת התמונה והתחלת הצגת השאלה
      setTimeout(() => {
        setShowImage(false) // מחבא את התמונה
        setTypeQ("q") // משנים את סוג השאלה לשאילה
        startQuestion() // פונקציה שמציגה את השאלה וההגדרות האחרות
      }, 8000)
      return
    } else if (questionData.type === "m") {
      isVideo = true
      setShowImage(true)
      // צור אלמנט וידאו נסתר כדי לבדוק את האורך
      const video = document.createElement("video")
      video.src = questionData.link
      video.addEventListener("loadedmetadata", () => {
        const duration = video.duration * 1000 // ממיר לשניות -> מילישניות
        setTimeout(() => {
          setShowImage(false)
          setTypeQ("q")
          startQuestion()
        }, duration)
      })
      return
    } else {
      startQuestion()
    }
  }

  // פונקציה להצגת השאלה
  const startQuestion = () => {
    console.log("test 2")
    setResetTimer(true)
    setVisibleQuestion(false)
    setVisibleAnswers(0)

    // שלב 1: הצגת השאלה
    setVisibleQuestion(true)
    setResetTimer(false)
    setStartProgress(true)

    // שלב 2: הצגת הטיימר
    setTimeout(() => {
      setViewCountdown(true)
      setStartProgress(false)
    }, 3000)

    setTimeout(() => {
      questionData.answers.forEach((_, index) => {
        setTimeout(
          () => {
            setVisibleAnswers(index + 1)
            // אם זו התשובה האחרונה
            if (index + 1 === questionData.answers.length) {
              // שליחת בקשה לסיום השאלה
              const params = new URLSearchParams()
              params.append("type", "q")
              params.append("game", gameId)
              fetch(`${API_URL}/end`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
                body: params.toString(),
              })
              // הפעלת הספירה לאחור להתחלה
              setTimeout(() => {
                setStartCountdown(true)
                setEndQ(true)
              }, 1000)
              playPause("startTimer")
            }
          },
          (index + 1) * 500,
        ) // הפרש של שנייה בין כל תשובה
      })
    }, 3000) // הצגת התשובות מתחילה 3 שניות לאחר הצגת הטיימר
  }

  useEffect(() => {
    if (isDemo) return // בהדגמה — תצוגה סטטית בלבד, בלי רצף חשיפה/מוזיקה
    displayQuestionAndAnswers()
  }, [questionData])

  //איפוס משחקz
  const resetQuiz = (type) => {
    if (type === "end") {
      if (startTiTiTi){
        return;
      }
      setIsStopTimer(true)
      stopAllMusic()
      navigate(`/winn/${gameId}`)
    }
    if (type === "reset") {
      if (startTiTiTi){
        return;
      }
      setIsStopTimer(true)
      stopAllMusic()
      navigate(`/toplay/${gameId}`)
    }
    if (type === "leaders") {
      if (startTiTiTi){
        return;
      }
      setIsStopTimer(true)
      stopAllMusic()
      navigate(`/leaders/${gameId}`)
    }
    if (endQ) {
      console.log(`Resetting quiz with type: ${type}`)
      setVisibleAnswers(0)
      setEndQ(false)
      playPause("stopTimer")
      setShowImage(false)
      setTimerEnd(false)
      setVisibleQuestion(false)
      setStartCountdown(false)
      setUpdates([])
      setQuestionData(null)
      setViewCountdown(false)
      setResetTimer(true)
      setStartProgress(false)
      setTypeQ("")
      loadQuestionData(type)
    }
  }

  // בקשת נתונים ראשוניים בכניסה לדף והתחברות לסוקט
  useEffect(() => {
    // מצב הדגמה — מזריקים שאלת דוגמה ותוצאות, בלי רשת/סוקט. הזרימה הרגילה תרנדר את המשחק.
    if (isDemo) {
      // תצוגה סטטית בלבד — בלי מוזיקה, בלי רצף חשיפה/המתנות. הכל גלוי מיד.
      // אם הועברה שאלה מהעורך (פרמטר q) — מציגים אותה; אחרת שאלת דוגמה.
      let previewQ = null
      try { const raw = searchParams.get("q"); if (raw) previewQ = JSON.parse(decodeURIComponent(raw)) } catch (e) {}
      const q = previewQ && previewQ.answers && previewQ.answers.length
        ? { id: 1, type: previewQ.type || "q", q: previewQ.q || "", answers: previewQ.answers, correctAnswer: previewQ.correctAnswer, answerTime: previewQ.answerTime }
        : { id: 1, type: "q", q: "מהי בירת ישראל?", answers: ["ירושלים", "תל אביב", "חיפה"], correctAnswer: 1 }
      const nAns = q.answers.length
      setInfoData({ theme: demoTheme, number: "079-000-0000", qCount: 10, answerTime: q.answerTime || 20, connectedPlayers: 20 })
      const demoUpdates = []
      const dist = [13, 4, 3, 2, 5, 1].slice(0, nAns)
      dist.forEach((cnt, ai) => {
        for (let k = 0; k < cnt; k++) demoUpdates.push({ phoneNumber: `05${ai}${k}`, answer: String(ai + 1), isCorrect: (q.correctAnswer === ai + 1) })
      })
      setUpdates(demoUpdates)
      setQuestionData(q)
      setTypeQ(q.type)
      setVisibleQuestion(true)
      setVisibleAnswers(nAns)
      setViewCountdown(true)
      setTimerEnd(true)        // מציג את גרפי התוצאות
      setStartProgress(false)
      return
    }

    loadGameData() //https://www.call2all.co.il/ym/dl.php?what=ivr2:8855/001.wav
    controlMusic(true, "/music/playing.mp3", true)
    loadQuestionData("next")

    // חיבור לסוקט
    const socket = io(WS_URL)

    socket.on("setCount", (data) => {
      setConnectedUsers(data.connectedPlayers)
    })

    socket.on("update-click", (data) => {
      console.log(data)
      if (data.answer === "9") {
        resetQuiz("next")
      } else {
        setUpdates((prevUpdates) => [...prevUpdates, data])
      }
    })

    return () => {
      socket.off("user-joined")
      socket.off("user-left")
      socket.off("update-click")
    }
  }, [])

  // חישוב אחוזי תשובות נכונות ושגויות
  const filteredUpdates = updates.filter((update) => update.phoneNumber && update.isCorrect)
  const first = filteredUpdates[0]?.phoneNumber ?? "--"
  const second = filteredUpdates[1]?.phoneNumber ?? "--"
  const correctAnswers = updates.filter((update) => update.isCorrect).length
  const incorrectAnswers = updates.length - correctAnswers
  const totalAnswers = updates.length
  const correctPercentage = (correctAnswers / totalAnswers) * 100 || 0
  const incorrectPercentage = (incorrectAnswers / totalAnswers) * 100 || 0

  // Dynamic answer stats — supports any number of answers
  const maxAnswers = questionData?.answers?.length || 4
  const answerToNumQ = Array.from({ length: maxAnswers }, (_, i) =>
    updates.filter((update) => update.answer === String(i + 1)).length
  )
  const answerPercentageToNumQ = answerToNumQ.map(count =>
    Math.floor((count / totalAnswers) * 100) || 0
  )

  // Is current question a survey?
  const isSurvey = questionData?.type === 's' || questionData?.type === 'S' || questionData?.correctAnswer === 'Q' || questionData?.type === 'g'

  console.log(answerPercentageToNumQ)
  console.log("Show Image:", showImage)

  const audioRef = useRef(new Audio()) // אובייקט שמע
  console.log(audioRef)
  const [songs, setSongs] = useState([]) // רשימה של שירים מנוגנים
  const audioRefs = useRef({}) // שמירת כל אובייקטי ה-Audio

  // פונקציה לשליטה בהשמעה
  const controlMusic = (play, songUrl, repeat = false) => {
    const songId = songUrl // נשתמש בלינק כ-ID של השיר

    if (play) {
      // אם השיר לא מנוגן כרגע, נטען את השיר החדש
      if (!audioRefs.current[songId]) {
        audioRefs.current[songId] = new Audio(songUrl)
        audioRefs.current[songId].volume = volume
      }

      // אם השיר מנוגן מחדש, נטען אותו מחדש
      if (audioRefs.current[songId].src !== songUrl) {
        audioRefs.current[songId].src = songUrl // אם רוצים להפעיל, מגדירים את השיר
      }

      audioRefs.current[songId].play().catch((error) => {
        console.error("Error playing audio:", error)
      }) // הפעלת המוזיקה

      if (repeat) {
        audioRefs.current[songId].onended = () => {
          controlMusic(true, songUrl, true) // חוזר על השיר
        }
      } else {
        audioRefs.current[songId].onended = () => {
          setIsPlaying(false) // מכיוון שהשיר נגמר, מעדכנים שהמוזיקה הפסיקה
        }
      }

      setSongs((prevSongs) => [...prevSongs, { songUrl, repeat }]) // הוספת השיר לרשימה
      setIsPlaying(true) // מעדכנים שהמוזיקה מנוגנת
    } else {
      // אם השיר הנוכחי תואם ללינק שנשלח להפסיק
      if (audioRefs.current[songId]) {
        audioRefs.current[songId].pause() // הפסקת המוזיקה
        audioRefs.current[songId].onended = null // מבטלים את החזרה האוטומטית אם יש
        delete audioRefs.current[songId] // מנקים את האובייקט של השיר מהרשימה
        setSongs((prevSongs) => prevSongs.filter((song) => song.songUrl !== songUrl)) // מסננים את השיר מהמצב
      }
    }
  }

  // פונקציה להפסיק את כל השירים
  // פונקציה להפסיק את כל השירים (לא מוחקת אותם)
  const stopAllMusic = () => {
    Object.keys(audioRefs.current).forEach((songId) => {
      // נשמור את המיקום של כל שיר ונסגור אותו
      const currentTime = audioRefs.current[songId].currentTime
      audioRefs.current[songId].pause() // הפסקת השיר
      setSongs((prevSongs) =>
        prevSongs.map((song) => (song.songUrl === songId ? { ...song, pausedAt: currentTime } : song)),
      )
    })
    setIsPlaying(false) // מכיוון שאין שירים מנוגנים
  }

  // פונקציה להמשיך שיר שנעצר
  const resumeMusic = (songUrl) => {
    const song = songs.find((s) => s.songUrl === songUrl)
    if (song && audioRefs.current[songUrl]) {
      const audio = audioRefs.current[songUrl]
      // ממשיכים את השיר מהמיקום שבו נעצר
      audio.currentTime = song.pausedAt || 0
      audio.play()
      setIsPlaying(true)
    }
  }

  const resumeAllMusic = () => {
    songs.forEach((song) => {
      if (song.pausedAt && audioRefs.current[song.songUrl]) {
        const audio = audioRefs.current[song.songUrl]
        // ממשיכים את השיר מהמיקום שבו נעצר
        audio.currentTime = song.pausedAt || 0
        audio.play()
      }
    })
    setIsPlaying(true) // מכיוון שהתחלנו להפעיל מוזיקה
  }

  // פונקציה לניהול השירים
  const playPause = (action, repeat = false) => {
    if (action === "wow") {
      setIsPlayingDrama(true)
      stopAllMusic()
      controlMusic(true, "/music/drama.mp3", repeat)
    } else if (action === "clap") {
      setIsPlayingClaps(true)
      controlMusic(
        true,
        "https://www.prog.co.il/attachments/%D7%9E%D7%97%D7%99%D7%90%D7%95%D7%AA-%D7%9B%D7%A4%D7%99%D7%99%D7%9D-mp3.319685/",
        repeat,
      )
    } else if (action === "stopClap") {
      setIsPlayingClaps(false)
      controlMusic(
        false,
        "https://www.prog.co.il/attachments/%D7%9E%D7%97%D7%99%D7%90%D7%95%D7%AA-%D7%9B%D7%A4%D7%99%D7%99%D7%9D-mp3.319685/",
        repeat,
      )
    } else if (action === "stopWow") {
      setIsPlayingDrama(false)
      controlMusic(false, "/music/drama.mp3", repeat)
      controlMusic(true, "/music/playing.mp3", true)
    } else if (action === "stopAll") {
      setIsPlayingAll(false)
      stopAllMusic()
    } else if (action === "startAll") {
      setIsPlayingAll(true)
      resumeAllMusic()
    } else if (action === "startTimer") {
      setStartTiTiTi(false)
      controlMusic(true, "/music/timer.wav", repeat)
    } else if (action === "stopTimer") {
      controlMusic(false, "/music/timer.wav", repeat)
    }
  } //stopAllMusic

  const handleVolumeChange = (event) => {
    const newVolume = event.target.value
    setVolume(newVolume)
    // לעדכן את הווליום של כל השירים
    Object.keys(audioRefs.current).forEach((songId) => {
      audioRefs.current[songId].volume = newVolume
    })
  }

  const formatValue = (value) => value.toFixed(0)

  return (
    <div dir="rtl" style={backgroundStyle}>
      {isDemo && (
        <div
          onClick={() => { if (window.opener) window.close(); else navigate(-1); }}
          style={{
            position: "fixed", top: "16px", left: "50%", transform: "translateX(-50%)", zIndex: 5000,
            background: "linear-gradient(135deg,#7c3aed,#a855f7)", color: "#fff", padding: "12px 32px",
            borderRadius: "30px", fontWeight: 800, fontSize: "1.05rem", cursor: "pointer",
            boxShadow: "0 6px 22px rgba(124,58,237,.5)", display: "flex", alignItems: "center", gap: "8px",
          }}
        >
          ← חזרה לפאנל &nbsp;·&nbsp; הדגמה
        </div>
      )}
      <div style={{ textAlign: "center", color: "white" }}>
        {/* 1. מספר החיוג - פינה שמאל עליון */}
        <Box
          sx={{
            position: "absolute",
            top: "0px",
            left: "0px",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            padding: "10px 20px",
            borderRadius: "8px 0px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            zIndex: 1000,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box sx={{ marginRight: "20px" }}>
            <Box sx={{ color: "white", fontSize: "1rem", marginBottom: "5px" }}>להצטרפות למשחק חייגו</Box>
            <Box sx={{ color: "rgb(75, 255, 183)", fontSize: "2rem", fontWeight: "bold" }}>
              {infoData?.number || ""}
            </Box>
          </Box>
          <Box sx={{ borderRight: "2px solid rgba(255, 255, 255, 0.5)", height: "100%", marginRight: "20px" }} />
          <Box sx={{ fontSize: "3rem", color: "rgb(75, 255, 183)" }}>📞</Box>
        </Box>

        {/* 2. החץ למעלה באמצע */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: "120px",
            height: "75px",
            backgroundColor: T.accent,
            clipPath: "polygon(0% 0%, 100% 0%, 85% 75%, 50% 100%, 15% 75%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            fontSize: "1.2rem",
            fontWeight: "bold",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
            zIndex: 1000,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "50%",
              transform: "translateX(-50%)",
              width: "110px",
              height: "70px",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              clipPath: "polygon(0% 0%, 100% 0%, 85% 75%, 50% 100%, 15% 75%)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box sx={{ color: "rgba(73, 143, 235, 0.3) 100%)", fontSize: "1rem", marginBottom: "3px" }}>שאילה</Box>
            <Box sx={{ fontSize: "1rem", fontWeight: "bold" }}>
              <Box component="span">{infoData?.qCount || ""}</Box>
              &nbsp;/&nbsp;
              <Box component="span" sx={{ color: "turquoise" }}>
                {questionData?.id || ""}
              </Box>
            </Box>
          </Box>
        </Box>

        {/* 3. האזור המרכזי - שלושה עמודות */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            height: "100vh",
            alignItems: "stretch",
            justifyContent: "space-between",
            paddingTop: "100px", // מקום לכותרת העליונה
            paddingBottom: "150px", // מקום לכפתורים
          }}
        >
          {/* עמודה ימנית - טיימר */}
          <Box
            sx={{
              width: "25%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {viewCountdown && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "222px",
                  height: "222px",
                  borderRadius: "50%",
                  backgroundColor: T.accentSoft,
                  color: T.timerText,
                  border: `3px solid ${T.accent}`,
                  fontSize: "4rem",
                  fontWeight: "bold",
                  textShadow: T.isImage ? "0 0 10px rgba(255, 255, 255, 0.8)" : "none",
                }}
              >
                <CountdownCircle
                  initialTime={questionData?.answerTime || infoData?.answerTime || 20}
                  start={startCountdown}
                  reset={resetTimer}
                  end={handleEnd}
                  pathColor={T.timerPath}
                  trailColor={T.timerTrail}
                />
              </Box>
            )}
          </Box>

          {/* עמודה מרכזית - שאלה ותשובות */}
          <Box
            sx={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            {(typeQ === "q" || typeQ === "s" || typeQ === "S" || typeQ === "g") && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                  maxWidth: "900px",
                  height: "100%",
                  justifyContent: "space-between",
                  paddingY: "20px",
                }}
              >
                {/* שאלה עם פס טעינה למעלה */}
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginBottom: "auto",
                  }}
                >
                  {visibleQuestion && (
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: "860px",
                        fontWeight: "bold",
                        border: isSurvey ? `2px solid ${T.surveyMain}` : T.qBorder,
                        fontSize: "clamp(1.6rem, 3.2vw, 3rem)",
                        lineHeight: 1.2,
                        wordBreak: "break-word",
                        fontFamily: T.font,
                        color: isSurvey ? "white" : T.qColor,
                        textAlign: "center",
                        padding: "25px",
                        background: isSurvey ? T.surveySoft : T.qBg,
                        backdropFilter: T.qBlur,
                        borderRadius: T.qRadius,
                        boxShadow: isSurvey
                          ? `0 4px 20px ${T.surveySoft}`
                          : T.qShadow,
                        position: "relative",
                        marginBottom: "20px",
                      }}
                    >
                      {questionData.q}
                      {isSurvey ? (
                        <Box sx={{
                          position: "absolute",
                          bottom: "-18px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          background: T.surveyMain,
                          color: "#fff",
                          fontSize: "1rem",
                          fontWeight: 700,
                          padding: "4px 22px",
                          borderRadius: "20px",
                          boxShadow: "0 3px 12px rgba(102, 126, 234, 0.5)",
                          letterSpacing: "1px",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          whiteSpace: "nowrap",
                        }}>
                          📊 סקר
                          {totalAnswers > 0 && (
                            <span style={{ fontSize: ".85rem", opacity: 0.85 }}>({totalAnswers} הצבעות)</span>
                          )}
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: "-22px",
                            left: "12px",
                            width: "44px",
                            height: "44px",
                            borderRadius: "50%",
                            background: T.badgeBg,
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "1.7rem",
                            fontWeight: 900,
                            boxShadow: "0 3px 10px rgba(0,0,0,.3)",
                          }}
                        >
                          ?
                        </Box>
                      )}
                    </Box>
                  )}

                  {/* פס טעינה מתחת השאילה ובאמצע */}
                  {startProgress && (
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "20px",
                      }}
                    >
                      <ProgressBar trailBg={T.progressTrail} borderColor={T.progressBorder} />
                    </Box>
                  )}
                </Box>

                {/* התשובות באמצע */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    width: "100%",
                    justifyContent: "center",
                    maxWidth: "min(96%, 1000px)",
                    gap: "15px",
                    zIndex: 100,
                    marginBottom: "auto",
                  }}
                >
                  {questionData.answers.map(
                    (answer, index) =>
                      index < visibleAnswers && (
                        <Box
                          key={answer}
                          sx={{
                            // עד 4 תשובות — גודל אחיד קבוע (לא נמתח); 5 ומעלה — קטן וגמיש
                            ...(questionData.answers.length <= 4
                              ? { flex: "0 0 auto", width: "220px", maxWidth: "220px" }
                              : { flex: "1 1 0", minWidth: "150px", maxWidth: "18%" }),
                            backgroundColor: isSurvey
                              ? "rgba(200, 210, 255, 0.75)"
                              : T.optBg,
                            borderRadius: isSurvey ? "12px" : T.optRadius,
                            boxShadow: isSurvey
                              ? "0 6px 20px rgba(102, 126, 234, 0.25)"
                              : T.optShadow,
                            ...(!isSurvey && T.optBorder !== "none" ? { border: T.optBorder } : {}),
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "space-between",
                            cursor: "pointer",
                            transition: "all 0.3s ease-in-out",
                            position: "relative",
                            minHeight: questionData.answers.length >= 5 ? "230px" : "300px",
                            ...(timerEnd && !isSurvey && questionData.correctAnswer === index + 1
                              ? {
                                  border: "3px solid #40e0d0",
                                  boxShadow: "0 0 15px 5px rgba(64, 224, 208, 0.7)",
                                }
                              : {}),
                            ...(timerEnd && !isSurvey && questionData.correctAnswer !== index + 1
                              ? {
                                  opacity: 0.8,
                                }
                              : {}),
                            ...(isSurvey
                              ? {
                                  border: `2px solid ${T.surveyMain}`,
                                  boxShadow: `0 6px 24px ${T.surveySoft}`,
                                }
                              : {}),
                          }}
                        >
                          {/* מספר התשובה */}
                          <Box
                            sx={{
                              position: "relative",
                              top: "-15px",
                              background: isSurvey ? T.surveyMain : T.badgeBg,
                              color: "white",
                              width: "40px",
                              height: "40px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontWeight: "bold",
                              borderRadius: isSurvey ? "5px" : T.badgeRadius,
                              transform: `rotate(${isSurvey ? "45deg" : T.badgeRotate})`,
                              zIndex: 1,
                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
                            }}
                          >
                            <Box sx={{ transform: `rotate(-${isSurvey ? "45deg" : T.badgeRotate})` }}>{index + 1}</Box>
                          </Box>

                          {/* טקסט התשובה */}
                          <Box
                            sx={{
                              fontSize: "1.8rem",
                              fontWeight: 700,
                              color: isSurvey ? "#222" : T.optText,
                              textAlign: "center",
                              paddingX: "12px",
                              marginTop: "10px",
                              marginBottom: "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              minHeight: "80px",
                            }}
                          >
                            {answer}
                          </Box>

                          {/* גרף התוצאות */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "flex-end",
                              height: isSurvey ? "120px" : "100px",
                              width: isSurvey ? "55px" : "45px",
                              margin: "1.5rem",
                              borderRadius: isSurvey ? "14px" : "10px",
                              border: isSurvey
                                ? "2px solid rgba(102, 126, 234, 0.6)"
                                : `2px solid ${T.accent}`,
                              background: isSurvey
                                ? "linear-gradient(180deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.1) 100%)"
                                : T.barBg,
                              boxShadow: isSurvey
                                ? "0 4px 16px rgba(102, 126, 234, 0.25)"
                                : "0 4px 12px rgba(0, 0, 0, 0.2)",
                              position: "relative",
                              overflow: "hidden",
                            }}
                          >
                            {(timerEnd || isSurvey) && (
                              <>
                                <Box
                                  sx={{
                                    position: "absolute",
                                    top: "5%",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    fontWeight: "bold",
                                    zIndex: 1,
                                    fontSize: isSurvey ? "1.1rem" : "1.2rem",
                                    color: isSurvey ? "rgba(255, 255, 255, 0.95)" : T.barPctColor,
                                    textShadow: isSurvey
                                      ? "0 1px 8px rgba(102, 126, 234, 0.8)"
                                      : "0 0 10px rgba(255, 255, 255, 0.8)",
                                  }}
                                >
                                  {`${answerPercentageToNumQ[index]}%`}
                                </Box>
                                <div
                                  style={{
                                    width: "100%",
                                    background: isSurvey
                                      ? "linear-gradient(178.28deg, rgb(128 170 255) 10.32%, rgb(87 130 255) 50.07%, rgb(102 126 234) 98.61%)"
                                      : questionData.correctAnswer === index + 1
                                        ? "linear-gradient(178.28deg, rgb(128 255 228) 10.32%, rgb(87 255 230) 50.07%, rgb(48 217 225) 98.61%)"
                                        : "linear-gradient(178.28deg, rgb(255 128 143) 10.32%, rgb(255 87 137) 50.07%, rgb(225 48 149) 98.61%)",
                                    height: `${answerPercentageToNumQ[index]}%`,
                                    transition: "height 0.5s ease-in-out",
                                    position: "absolute",
                                    bottom: 0,
                                    left: 0,
                                  }}
                                />
                              </>
                            )}
                          </Box>

                          {/* מידע על שחקנים */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                              border: isSurvey
                                ? "2px solid rgba(102, 126, 234, 0.5)"
                                : T.softBorder,
                              height: isSurvey ? "58px" : "50px",
                              backgroundColor: (timerEnd || isSurvey)
                                ? (isSurvey ? "rgba(102, 126, 234, 0.25)" : "rgba(0, 0, 0, 0.3)")
                                : "transparent",
                              borderRadius: isSurvey ? "0 0 12px 12px" : "5px 0px 0px 5px",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                              padding: "10px",
                              visibility: (timerEnd || isSurvey) ? "visible" : "hidden",
                            }}
                          >
                            {(timerEnd || isSurvey) && (
                              <>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#ffffff",
                                  }}
                                >
                                  {isSurvey ? (
                                    <Box sx={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
                                      <Box sx={{ fontSize: "1.4rem", fontWeight: "bold", textShadow: "0 0 10px rgba(102, 126, 234, 0.8)" }}>
                                        {answerToNumQ[index]}
                                      </Box>
                                      <Box sx={{ fontSize: ".85rem", color: "rgba(255,255,255,0.7)" }}>
                                        הצבעות
                                      </Box>
                                      <Box sx={{
                                        fontSize: ".85rem",
                                        fontWeight: 700,
                                        background: "rgba(102, 126, 234, 0.4)",
                                        borderRadius: "8px",
                                        padding: "1px 8px",
                                        marginLeft: "4px",
                                        color: "#fff",
                                      }}>
                                        {answerPercentageToNumQ[index]}%
                                      </Box>
                                    </Box>
                                  ) : (
                                    <>
                                      <Box
                                        sx={{
                                          fontSize: "1.5rem",
                                          fontWeight: "bold",
                                          textShadow: "0 0 10px rgba(255, 255, 255, 0.8)",
                                        }}
                                      >
                                        {answerToNumQ[index]}
                                      </Box>
                                      <Box
                                        sx={{
                                          fontSize: "1rem",
                                          color: "rgba(255, 255, 255, 0.8)",
                                        }}
                                      >
                                        שחקנים
                                      </Box>
                                    </>
                                  )}
                                </Box>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    setPlayersDialogAnswer(index + 1)
                                    setPlayersDialogOpen(true)
                                  }}
                                  style={{
                                    padding: "5px 10px",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    color: "#ffffff",
                                    backgroundColor: isSurvey ? "rgba(102, 126, 234, 0.6)" : T.pillBg,
                                    border: isSurvey ? "1px solid rgba(255,255,255,0.5)" : "1px solid white",
                                    borderRadius: isSurvey ? "8px" : "5px",
                                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                                    cursor: "pointer",
                                  }}
                                >
                                  {isSurvey
                                    ? (questionData.answers.length > 3 ? "👥" : "👥 מצביעים")
                                    : (questionData.answers.length > 3 ? "שחקנים" : "הצגת שחקנים")}
                                </button>
                              </>
                            )}
                          </Box>
                        </Box>
                      ),
                  )}
                </Box>
              </Box>
            )}
          </Box>

          {/* עמודה שמאלית - שחקנים */}
          <Box
            sx={{
              width: "25%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  width: "150px",
                  height: "150px",
                  borderRadius: "10px",
                  backgroundColor: T.statBg,
                  color: T.statText,
                  border: T.statBorder,
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                  textAlign: "center",
                  marginBottom: "20px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    textShadow: "0 0 10px rgba(255, 255, 255, 0.8)",
                    fontSize: "3rem",
                    fontWeight: "bold",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box component="span">{connectedUsers}</Box>
                  &nbsp;/&nbsp;
                  <Box component="span" sx={{ color: "turquoise" }}>
                    {totalAnswers}
                  </Box>
                </Box>
                <Box
                  sx={{
                    fontSize: "1.5rem",
                    color: "rgba(255, 255, 255, 0.8)",
                  }}
                >
                  שחקנים
                </Box>
              </Box>

              {/* ריבועי תוצאות */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <Box
                  sx={{
                    width: "80px",
                    height: "35px",
                    border: "1px solid rgba(75, 255, 183, 0.8)",
                    backgroundColor: T.statBg,
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "rgba(75, 255, 183, 1)",
                    textShadow: "0 0 10px rgba(255, 255, 255, 0.8)",
                  }}
                >
                  {correctAnswers}
                </Box>
                <Box
                  sx={{
                    width: "80px",
                    height: "35px",
                    backgroundColor: T.statBg,
                    border: "1px solid rgba(255, 75, 75, 0.8)",
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "rgba(255, 75, 75, 1)",
                    textShadow: "0 0 10px rgba(255, 255, 255, 0.8)",
                  }}
                >
                  {incorrectAnswers}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* 4. כפתורי הבקרה - תחתית הדף (בהדגמה — נעולים, לא ניתן ללחוץ) */}
        <Box
          sx={{
            position: "fixed",
            left: "50%",
            transform: "translateX(-50%)",
            width: "60%",
            height: "60px", // ← נמוך יותר
            background: T.ctrlBarBg,
            ...(isDemo ? { pointerEvents: "none", opacity: 0.6 } : {}),
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            gap: "20px",
            boxShadow: "0 -4px 10px rgba(0, 0, 0, 0.5)",
            borderRadius: "15px 15px 0 0",
            padding: "0px 20px",
            bottom: 0,
            zIndex: 2,
          }}
        >
          {/* סליידר ווליום */}
          <Box
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginRight: "10px",
            }}
          >
            <Box
              sx={{
                height: "70px",
                backgroundColor: T.ctrlBtnBg,
                borderRadius: "10px 10px 0 0",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "5px",
              }}
            >
              <Slider
                aria-label="Volume"
                orientation="vertical"
                value={volume}
                onChange={handleVolumeChange}
                step={0.01}
                min={0}
                max={1}
                valueLabelDisplay="off"
                sx={{
                  height: 45,
                  color: "rgba(75, 255, 183, 1)",
                  "& .MuiSlider-thumb": {
                    width: 10,
                    height: 10,
                    backgroundColor: "#fff",
                  },
                }}
              />
            </Box>
          </Box>

          {/* כפתורי הפעולה */}
          {buttons.map((button) => (
            <Box
              key={button.id}
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "60px",
                gap: "4px",
              }}
            >
              {/* רקע חום מתחת למשושה */}
              <Box
                sx={{
                  width: "60px",
                  height: "70px",
                  backgroundColor: T.ctrlBtnBg,
                  borderRadius: "10px 10px 0 0",
                  position: "absolute",
                  bottom: 0,
                  zIndex: 0,
                }}
              />
              {/* משושה */}
              <Box
                sx={{
                  width: "45px",
                  height: "45px",
                  background: T.ctrlHex,
                  clipPath: "polygon(50% 0%, 85% 15%, 100% 50%, 85% 85%, 50% 100%, 15% 85%, 0% 50%, 15% 15%)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
                  zIndex: 1,
                  cursor: "pointer",
                }}
                onClick={() => (button.type === "res" ? resetQuiz(button.action) : playPause(button.action))}
              >
                {/* עיגול פנימי */}
                <Box
                  sx={{
                    width: "28px",
                    height: "28px",
                    backgroundColor: T.ctrlBtnBg,
                    color: T.ctrlIconColor,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.5)",
                  }}
                >
                  {button.icon}
                </Box>
              </Box>
              {/* טקסט פעולה */}
              <Box
                sx={{
                  fontSize: "0.7rem",
                  fontWeight: "bold",
                  color: T.ctrlText,
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                  zIndex: 1,
                }}
                title={button.text}
              >
                {button.text}
              </Box>
            </Box>
          ))}
        </Box>

        {/* תמונה/וידאו overlay */}
        {showImage && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
            onClick={() => setShowImage(false)}
          >
            <Box onClick={(e) => e.stopPropagation()}>
              <img
                src={questionData.link || "/placeholder.svg?height=400&width=600"}
                alt="Overlay"
                style={{ maxWidth: "90vw", maxHeight: "90vh", borderRadius: "12px" }}
              />
            </Box>
          </Box>
        )}

        {/* דיאלוג הצגת שחקנים שענו */}
        <Dialog
          open={playersDialogOpen}
          onClose={() => setPlayersDialogOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "20px",
              background: "linear-gradient(180deg, #1a1a2e 0%, #16213e 100%)",
              border: "2px solid rgba(64, 224, 208, 0.3)",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.6), 0 0 30px rgba(64, 224, 208, 0.15)",
              color: "#fff",
              direction: "rtl",
            },
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid rgba(255,255,255,.1)",
              pb: 1.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  width: 40, height: 40, borderRadius: "10px",
                  background: "linear-gradient(135deg, rgba(199, 159, 28, 0.8), rgba(255, 216, 131, 0.8))",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontWeight: "bold", fontSize: "1.2rem", color: "#1a1a2e",
                }}
              >
                {playersDialogAnswer}
              </Box>
              <Box>
                <Typography sx={{ fontWeight: 700, fontSize: "1.1rem" }}>
                  {questionData?.answers?.[playersDialogAnswer - 1] || `תשובה ${playersDialogAnswer}`}
                </Typography>
                <Typography sx={{ fontSize: ".75rem", color: "rgba(255,255,255,.5)" }}>
                  {updates.filter(u => u.answer === String(playersDialogAnswer)).length} שחקנים ענו
                </Typography>
              </Box>
            </Box>
            <IconButton onClick={() => setPlayersDialogOpen(false)} sx={{ color: "rgba(255,255,255,.6)" }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: "16px !important", pb: 3, maxHeight: 400 }}>
            {(() => {
              const answeredPlayers = updates.filter(u => u.answer === String(playersDialogAnswer))
              if (answeredPlayers.length === 0) {
                return (
                  <Box sx={{ textAlign: "center", py: 4 }}>
                    <Typography sx={{ fontSize: "2.5rem", mb: 1 }}>🤷</Typography>
                    <Typography sx={{ color: "rgba(255,255,255,.5)", fontWeight: 600 }}>אין שחקנים שענו תשובה זו</Typography>
                  </Box>
                )
              }
              return answeredPlayers.map((player, i) => (
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    mb: 1,
                    borderRadius: "12px",
                    background: player.isCorrect
                      ? "linear-gradient(135deg, rgba(64, 224, 208, 0.15), rgba(64, 224, 208, 0.05))"
                      : "rgba(255,255,255,.05)",
                    border: `1px solid ${player.isCorrect ? "rgba(64, 224, 208, 0.3)" : "rgba(255,255,255,.08)"}`,
                    transition: "all .2s",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Box
                      sx={{
                        width: 36, height: 36, borderRadius: "50%",
                        background: player.isCorrect
                          ? "linear-gradient(135deg, #40e0d0, #00b4d8)"
                          : "linear-gradient(135deg, #667, #555)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontWeight: 700, fontSize: ".85rem", color: "#fff",
                      }}
                    >
                      {i + 1}
                    </Box>
                    <Box>
                      <Typography sx={{ fontWeight: 700, fontSize: ".9rem" }}>
                        {player.playerName || player.phoneNumber || "אנונימי"}
                      </Typography>
                      {player.playerName && player.phoneNumber && (
                        <Typography sx={{ fontSize: ".72rem", color: "rgba(255,255,255,.4)" }}>
                          {player.phoneNumber}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Chip
                    label={player.isCorrect ? "✓ נכון" : "✗ שגוי"}
                    size="small"
                    sx={{
                      fontWeight: 700,
                      fontSize: ".7rem",
                      background: player.isCorrect ? "rgba(64, 224, 208, 0.2)" : "rgba(255, 100, 100, 0.2)",
                      color: player.isCorrect ? "#40e0d0" : "#ff6b6b",
                      border: `1px solid ${player.isCorrect ? "rgba(64, 224, 208, 0.3)" : "rgba(255, 100, 100, 0.3)"}`,
                    }}
                  />
                </Box>
              ))
            })()}
          </DialogContent>
        </Dialog>
      </div>
    </div>
  )
}

export default App
